export default "__VITE_PUBLIC_ASSET__efdd269e__"